/*=============================================== YoutubePage ===============================================*/

import { Youtube } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

const YoutubePage = () => {
    const items: ItemType[] = [
        {
            content: (
                <Youtube src="https://www.youtube.com/watch?v=33KKr1ZGSzg" />
            ),
            code: '<Youtube src="https://www.youtube.com/watch?v=33KKr1ZGSzg" />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "src",
            type: "string",
            required: true,
        },
        {
            subtitle: "width",
            type: "string or number",
            default: "100%",
        },
        {
            subtitle: "height",
            type: "string or number",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default YoutubePage
